import React from 'react';
import { Card, Col } from 'reactstrap';

const Overview = ({ detail }) => {
    return (
        <React.Fragment>
            <Col xl={4}>
                <Card 
                    className="bg-dark text-white rounded-3 overflow-hidden position-sticky shadow-lg" 
                    style={{ top: "80px" }} // Sayfa scroll olduğunda ekranda sabit kalsın diye
                >
                    <div 
                        className="p-4 text-center h-100" 
                        style={{ backgroundColor: "rgba(0,0,0,0.4)" }}
                    >
                        <div className="mb-3 mt-2">
                            <i className="mdi mdi-lock text-white" style={{ fontSize: "50px" }}></i>
                        </div>
                        
                        <h4 className="text-white mb-3">Taşıma No. {detail.id}</h4>
                        
                        <p className="text-light fs-14 mb-4" style={{ lineHeight: "1.6" }}>
                            Ulaşımın belirli kısıtlamaları nedeniyle, teklif baskısı yalnızca mobil uygulamada mevcuttur.
                        </p>
                        
                        {/* QR Kod Alanı */}
                        <div className="bg-white p-2 rounded d-inline-block mb-3">
                            <i className="mdi mdi-qrcode-scan display-1 text-dark"></i>
                        </div>
                        
                        <div className="text-light fs-14 mb-3 fw-medium">
                            <span className="d-block mb-1">⬆️ Görev detaylarına erişin</span>
                            <span className="d-block">Bu QR Kodunu taramak 📸</span>
                        </div>
                    </div>
                </Card>
            </Col>
        </React.Fragment>
    );
}

export default Overview;